import React from 'react'
import { StyledMessage } from './FallbackMessage.styled'

export function FallbackMessage(props: { message: string }) {
    return (
        <StyledMessage>
            <p>{props.message}</p>
        </StyledMessage>
    )
}
